export const STANDARD_CACHE = 'i18n-cached-standard-locales';
export const PUBLIC_CACHE = 'i18n-cached-public-locales';
